import { NotFound } from './pages';

export default {
  key: 'not-found',
  path: '/not-found',
  exact: true,
  component: NotFound,
};
